import { Link } from "react-router-dom";
import { Plus } from "lucide-react";

export function MobileFab({ to, label, testid }) {
  return (
    <Link to={to} data-testid={testid} aria-label={label}
      className="lg:hidden fixed z-30 right-4 bottom-[max(1rem,env(safe-area-inset-bottom))] h-14 pl-4 pr-5 rounded-full bg-amber-500 text-slate-950 font-bold shadow-xl shadow-amber-500/30 flex items-center gap-2 active:scale-95 transition-transform">
      <Plus className="h-5 w-5" /> {label}
    </Link>
  );
}
